import React from 'react';

export default function NoMatch() {
  return <p className="construction-text text-center">Sorry! Webpage does not exist!</p>;
}
